import firebase from 'firebase/app';
import 'firebase/functions';
import 'firebase/firestore';
import 'firebase/auth';
import firebaseConfig from '../firebase-config';
import vars from './vars';

firebase.initializeApp(firebaseConfig);

const functions = firebase.app().functions(vars.REGION);

if (window.location.href.match(/localhost:5000/)) {
    functions.useFunctionsEmulator(vars.EMULATOR_URL);
}

export { functions };
export const db = firebase.firestore();
export const auth = firebase.auth();
